// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card--3Rgv7","revision_fts_version":"styles__revision_fts_version--1Ab0w"};